import React from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  InputAdornment,
  TextField,
  Divider,
  Autocomplete,
} from "@mui/material";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import EscalationService from "src/service/escalation";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { writeFile } from "xlsx";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import TimeSlotService from "src/service/timeslot";
import GeofencingService from "src/service/geofencing";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Point of Interest",
  },
];

const Escalation_list = () => {
  const navigate = useNavigate();
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [escalationData, setEscalationdata] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [visibleData, setVisibleData] = useState([]);

  //  for table sorting
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("vehicle_no"); // Initial column to sort

  const [district_list, setdistrict_list] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");

  const fetch_district_data = async () => {
    try {
      const res = await GeofencingService.fetch_district_list({});
      // console.log("res.data", res.data);
      setdistrict_list(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [shift_data, setshift_data] = useState([]);
  const [selected_shift_data, setselected_shift_data] = useState("");

  const fetch_shift_data = async () => {
    try {
      const res = await TimeSlotService.get_slot_data({});
      // console.log("res.data", res.data);
      setshift_data(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_district_data();
    fetch_shift_data();
  }, []);

  const user_type = sessionData.data.user_type;

  const fetch_escalation_data = async () => {
    try {
      let res; // Declare 'res' outside the if-else blocks

      if (user_type === 3 || user_type === 4) {
        res = await EscalationService.get_escalation_list({
          district_id: sessionData.data.district_id || "",
          vehicle_type: sessionData.data.vehicle_type || "",
          shift_id: selected_shift_data,
        });
      } else {
        res = await EscalationService.get_escalation_list({
          district_id: selectedDistrict,
          vehicle_type: sessionData.data.vehicle_type || "",
          shift_id: selected_shift_data,
        });
      }

      // console.log("res.data===", res.data);
      setEscalationdata(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_escalation_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected_shift_data, selectedDistrict, sessionData.data.vehicle_type]);

  const filteresclation = escalationData.filter(
    (man) =>
      (man.vehicle_no &&
        man.vehicle_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (man.district_name &&
        man.district_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (man.erv_no &&
        man.erv_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (man.shift_name &&
        man.shift_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (man.location_name &&
        man.location_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (man.radius &&
        man.radius.toString().includes(searchTerm.toLowerCase())) ||
      (man.lat && man.lat.toString().includes(searchTerm.toLowerCase())) ||
      (man.lng && man.lng.toString().includes(searchTerm.toLowerCase()))
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = escalationData.filter((man) =>
      man.vehicle_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [escalationData, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const delete_escalation = async (id) => {
    swal({
      title: "Delete Escalation",
      text: "Are you sure you want to delete ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await EscalationService.delete_escalation({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetch_escalation_data();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  const handleExport = () => {
    const headers = [
      "Sl. No",
      "Vehicle No",
      "District Name",
      "ERV No",
      "Shift Name",
      "Place Name",
      "Lat",
      "Lng",
      "Radius",
    ];

    const data = visibleData.map((man, index) => [
      index + 1,
      man?.vehicle_no,
      man?.district_name,
      man?.erv_no !== null && man?.erv_no !== "ABC" ? man.erv_no : "NA",
      man?.shift_name,
      man?.location_name,
      man?.lat,
      man?.lng,
      man?.radius,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "Point of Interest Report.xlsx";

    writeFile(wb, fileName);
  };

  // table column sorting start here
  // eslint-disable-next-line no-unused-vars
  const handleSort = (column) => {
    // Toggle sorting order if clicking on the same column
    if (sortColumn === column) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      // Set new column to sort
      setSortColumn(column);
      // Default sorting order for the new column
      setSortOrder("asc");
    }
  };

  const sortedEsclation = filteresclation.sort((a, b) => {
    const compareValueA = a[sortColumn];
    const compareValueB = b[sortColumn];

    // Customize the comparison based on data types or specific conditions
    if (sortOrder === "asc") {
      return compareValueA.localeCompare(compareValueB);
    } else {
      return compareValueB.localeCompare(compareValueA);
    }
  });

  // ====================================
  return (
    <PageContainer
      title="Point of Interest"
      description="this is Basic Table page"
    >
      {/* breadcrumb */}
      <Breadcrumb title="Point of Interest" items={BCrumb} />
      {/* end breadcrumb */}

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Point of Interest
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/addEscalation");
              }}
            >
              <IconPlus width={20} />
            </Button>

            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center" spacing={3}>
          {(user_type === 1 || user_type === 2) && (
            <Grid
              item
              lg={4}
              md={4}
              sm={6}
              xs={12}
              sx={{
                marginBottom: "15px;",
                marginTop: "15px;",
              }}
            >
              <CustomFormLabel>District</CustomFormLabel>
              <Autocomplete
                id="disrict_id"
                name="disrict_id"
                options={district_list}
                getOptionLabel={(option) => option.district_name}
                value={
                  district_list.find(
                    (option) => option.id === selectedDistrict
                  ) || null
                }
                onChange={(event, newValue) =>
                  setSelectedDistrict(newValue ? newValue.id : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select District"
                    fullWidth
                  />
                )}
              />
            </Grid>
          )}

          <Grid
            item
            lg={4}
            md={4}
            sm={6}
            xs={12}
            sx={{
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <CustomFormLabel>Shift Name</CustomFormLabel>
            <Autocomplete
              id="shift_id"
              name="shift_id"
              options={shift_data}
              getOptionLabel={(option) => option.shift_name}
              value={
                shift_data.find(
                  (option) => option.id === selected_shift_data
                ) || null
              }
              onChange={(event, newValue) =>
                setselected_shift_data(newValue ? newValue.id : "")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Shift"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            sm={6}
            xs={12}
            sx={{
              marginBottom: "15px",
              marginTop: "40px",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder=" Search "
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>
        {/* </ParentCard> */}

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={
                {
                  // whiteSpace: "nowrap",
                }
              }
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography style={{ fontSize: "14px" }} variant="h6">
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      District Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      ERV No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Shift Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Place Name
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Latitude
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Longitude
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Radius
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedEsclation.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={11} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedEsclation
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {index + 1}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.vehicle_no ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.district_name ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.erv_no !== null && man?.erv_no !== "ABC"
                              ? man.erv_no
                              : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.shift_name ?? "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.location_name ?? "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.lat ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.lng ?? "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: "center" }}>
                          <Typography style={{ fontSize: "13px" }} variant="h6">
                            {man?.radius ?? "NA"}
                          </Typography>
                        </TableCell>

                        <TableCell
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Link to={`/updateEscalation/${man.id}`}>
                            <ModeEditOutlinedIcon
                              style={{
                                color: "blue",
                                fontSize: "18px",
                                cursor: "pointer",
                              }}
                            />
                          </Link>
                          <DeleteOutlinedIcon
                            style={{
                              color: "red",
                              fontSize: "18px",
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => delete_escalation(man.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={sortedEsclation.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default Escalation_list;
